import { isEmpty } from 'lodash'

export default {
  isSet() {
    return typeof this.submission.id === 'string'
  },
  isAllValid() {
    return isEmpty(this.stepsErrors) && isEmpty(this.requiredErrorsOnly)
  },
  setSubscription() {
    this.unsubscribe = this.$store.subscribe((mutation, state) => {
      if (mutation.type === 'submissions/updateStatus') {
        this.updateSubmissionSteps()
      }
    })
  },
  setOpenStep() {
    if (this.submission.progress) {
      /**
       * Reset open to false.
       */
      this.steps.forEach(step => {
        step.open = false
      })
      /**
       * Set first inProgress to open.
       */
      Object.keys(this.submission.progress).some((section, idx) => {
        if (['in_progress', 'empty'].indexOf(this.submission.progress[section]) > -1) {
          this.steps[idx].open = true
          return true
        }
      })
    }
  },
  setStatusUpdater() {
    if (typeof this.submission.status === 'string') {
      if (['in_work', 'in_correction'].indexOf(this.submission.status) > -1) {
        /**
         * Update the submission continuously.
         * Validationservices might update the submission validation data in the background.
         * To display notifications in theses cases, dispatch an update to receive latest data from API.
         * Using submissions/update makes sure that the latest data from $store is used. (in case client changes are not yet on server).
         */
        this.statusTimer.set(this.updateSubmissionStatus, 30000)
      }
    }
  },
  accordionItemClass(section) {
    return [
      this.$style.item,
      { [this.$style.complete]: this.step(section).complete },
      { [this.$style.error]: this.step(section).anyErrors() }
    ]
  },
  navigateToHome() {
    this.$router.push({
      name: 'home'
    })
  },
  createNewSubmission() {
    return new Promise(resolve => {
      this.createSubmission().then(submission => {
        this.$router.push({
          name: 'submissions_id',
          params: {
            id: (submission || {}).id
          }
        })
        resolve(submission)
      })
    })
  }
}
